import axios from 'axios';
const API_PREFIX = process.env.REACT_APP_API_PREFIX;
export const getAll = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/divisioncities${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getRRBCity = async (param, extra = '') => {
  let filter =
    '?' +
    extra +
    (param
      ? Object.keys(param)
          .filter((key) => param[key] !== '')
          .map(function (key) {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(param[key])
            );
          })
          .join('&')
      : '');
  return await axios
    .get(`${API_PREFIX}/divisioncities/rrb${filter}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const getDivisionCity = async (id) => {
  return await axios
    .get(`${API_PREFIX}/divisioncities/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const create = async (payload) => {
  return await axios
    .post(`${API_PREFIX}/divisioncities`, payload)
    .then((res) => {
      return res.data;
      //normal comment
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const update = async (id, payload) => {
  return await axios
    .put(`${API_PREFIX}/divisioncities/${id}`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const remove = async (id) => {
  return await axios
    .delete(`${API_PREFIX}/divisioncities/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getDivisionCityById = async (id) => {
  return await axios
    .get(`${API_PREFIX}/divisioncities/cityid/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
